export default __webpack_public_path__ + "static/media/settings.9b51a366.svg";